import Rails from '@rails/ujs'
import { Controller } from 'stimulus'
import Uppy from '@uppy/core'
import Dashboard from '@uppy/dashboard'
import AwsS3 from '@uppy/aws-s3'
import Spanish from '@uppy/locales/lib/es_ES'

export default class extends Controller {
  static targets = ['form', 'hiddenInput', 'nameInput', 'spinner', 'uppy']

  connect () {
    this.load()
  }

  load () {
    Spanish.strings.browse = 'Permitidos: 1'

    const uppy = Uppy({
      id: `document-uploader-${Date.now()}`,
      autoProceed: true,
      restrictions: {
        maxFileSize: 10485760, // 10MB
        maxNumberOfFiles: 1,
        minNumberOfFiles: 1,
        allowedFileTypes: ['.xlsx', '.csv', '.pdf', '.dwg', '.ai']
      },
      locale: Spanish
    })
      .use(Dashboard, {
        inline: true,
        target: this.uppyTarget,
        height: 50,
        width: 200,
        thumbnailWidth: 350,
        thumbnailType: 'pdf/xlsx',
        showProgressDetails: true,
        hideProgressAfterFinish: false,
        showLinkToFileUploadResult: false,
        note: 'Sólo archivos de xlsx/pdf/csv/dwg/ai',
        disableStatusBar: false,
        disableInformer: false,
        disableThumbnailGenerator: false,
        proudlyDisplayPoweredByUppy: false,
        locale: Spanish,
        showRemoveButtonAfterComplete: true,
        doneButtonHandler: () => {
          uppy.reset()
        }
      })
      .use(AwsS3, {
        companionUrl: '/'
      })

    uppy.on('upload-success', (file, response) => {
      const uploadedFileData = JSON.stringify({
        id: file.meta.key.match(/^cache\/(.+)/)[1],
        storage: 'cache',
        metadata: {
          size: file.size,
          filename: file.name,
          mime_type: file.type
        }
      })

      this.hiddenInputTarget.value = uploadedFileData
      this.nameInputTarget.value = file.name

      this.spinnerTarget.classList.remove('d-none')

      Rails.fire(this.formTarget, 'submit')

      uppy.reset()
    })

    uppy.on('complete', (result) => {
      uppy.reset()
    })
  }
}
